import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapCollection } from './normalize'

async function generateByYear({ farmId, year }) {
  const response = await apiClient.post(`${endpoints.metricsProvider}/all`, { farmId, year })
  return unwrapCollection(response)
}

async function getZipByYear({ farmId, year }) {
  const response = await apiClient.get(`${endpoints.metricsProvider}/zip`, {
    params: { farmId, year },
    responseType: 'blob',
  })
  return response.data
}

export const metricsProviderService = { generateByYear, getZipByYear }
